import { ethers } from "ethers";

export const contractAddress = "0xbCB408BC9913cc8f9C3A5DDc257F801aE2915207";

export const abi = [
  "function admin() view returns(address)",
  "function isOfficer(address) view returns(bool)",
  "function proposalCount() view returns(uint256)",
  "function pendingElectionCount() view returns(uint256)",
  "function pendingElections(uint256) view returns(string,string,uint256,uint256,bool)",
  "function proposeElection(string,string,uint256)",
  "function approveElection(uint256)",
  "function getProposal(uint256) view returns(string,string,uint256,uint256,uint256)",
  "function hasVoted(uint256,address) view returns(bool)",
  "function vote(uint256,bool)",
  "function adminCreateElection(uint256)",
  "function addOfficer(address)"
];

export async function connectWallet() {
  if (!window.ethereum) throw new Error("Install MetaMask");

  await window.ethereum.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: "0xaa36a7" }], // Sepolia
  });

  await window.ethereum.request({ method: "eth_requestAccounts" });
  const provider = new ethers.BrowserProvider(window.ethereum, "any");
  const signer = await provider.getSigner();
  const contract = new ethers.Contract(contractAddress, abi, signer);

  const account = await signer.getAddress();
  return { account, contract };
}

export async function getReadContract() {
  const provider = new ethers.BrowserProvider(window.ethereum);
  return new ethers.Contract(contractAddress, abi, provider);
}
